export function getUseAllDocsQueryParameter(params) {
  return getQueryParameter({
    params: params,
    name: 'use_all_docs',
    defaultValue: true,
  });
}

export function getQueryParameter({ params, name, defaultValue = '' }) {
  return params && params[name] !== undefined ? params[name] : defaultValue;
}
